import React from 'react';
import PropTypes from 'prop-types';
import { Border } from 'components/MsnbcDaily/Border';

import styles from './styles.module.scss';

function Header({
  description,
  title,
}) {
  return (
    <div className={styles.msnbcDailyHeader}>
      <Border />
      {title && description && (
        <div className={styles.inner}>
          {title && (
            <h2 className={styles.title}>
              {title}
            </h2>
          )}
          {description && (
            <div className={styles.description}>
              {description}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

Header.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};

Header.defaultProps = {
  description: null,
  title: null,
};

export { Header };
